import { getPostHog } from './_posthog.client';

export function isFeatureEnabled(flag: string): boolean | undefined {
  return getPostHog()?.isFeatureEnabled(flag);
}

export function reloadFlags() {
  getPostHog()?.reloadFeatureFlags();
}

export function onFlagsUpdated(callback: () => void) {
  getPostHog()?.onFeatureFlags(callback);
}
